import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus } from '../../../../../shared/types/analytics';

export interface ITrackPayButtonClickParams {
  source: string;
  amount: number;
  offerStatus: TAnalyticsOfferStatus;
}

export const getEventActionPrefix = (source: string) => {
  if (source === 'refill') {
    return 'enough_money_popup';
  }

  return 'not_enough_money_popup';
};

export const trackPayButtonClick = ({ source, amount, offerStatus }: ITrackPayButtonClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action:  `${getEventActionPrefix(source)}_try_to_pay`,
    label: String(amount),
  });
};

export const trackOtherPaymentMethodClick = (source: string, offerStatus: TAnalyticsOfferStatus) => () => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: `${getEventActionPrefix(source)}_payment_type`,
  });
};

export const trackPayAsLegalClick = (source: string, offerStatus: TAnalyticsOfferStatus) => () => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: `${getEventActionPrefix(source)}_urlico`,
  });
};
